import Image from "next/image";
import {Link} from "@/i18n/routing";
import {useTranslations} from 'next-intl';
import {ProductTag, ProductTagColors} from '@/libs/constants/common.constants';
import ProductCardViewPort from '@/components/shared/cards/ProductCardViewPort';
import ProductPrice from '@/components/shared/cards/ProductPrice';

export default function ProductCardPrimary2({ product, clientType }) {
  const t = useTranslations('catalog');
  
  return (
    <div className="ltn__product-item ltn__product-item-3">
      <div className="product-img">
        <Link href={`/products/${product.alt}`}>
          <Image
              src={product.coverImage}
              alt={product.id}
              width={1000}
              height={1000}
              loading="lazy"
              style={{aspectRatio: 1, objectFit: 'cover', height: 'auto'}}
          />
        </Link>
        {
          product.tag ? (
              <div className={`product-badge pb-${ProductTagColors[product.tag]}`}>
                <ul>
                  <li className="sale-badge">
                    {t(`productTags.${product.tag}`)}
                    {product.discount > 0 && product.tag === ProductTag.SALE ? <span>{` -${product.discount * 100}%`}</span> : ''}
                  </li>
                </ul>
              </div>
          ) : ''
        }
      </div>
      <div className="product-info">
        <h2 className="product-title">
          <Link href={`/products/${product.alt}`}>{product.title}</Link>
        </h2>
        {
          product.reviewComputed ? (
              <div className="product-ratting" title={product.reviewComputed.average}>
                <ul>
                {
                    product.reviewComputed.stars.map((icon, i) => (
                        <li key={i}>
                          <i className={icon}></i>
                        </li>
                    ))
                  }
                </ul>
              </div>
          ) : ''
        }
        <ProductPrice price={product.price} clientType={clientType}/>
        <div className="product-brief">
          <p>{product.descriptionShort}</p>
        </div>
        <ProductCardViewPort product={product}/>
      </div>
    </div>
  );
};
